import {  
  MethodsFastReport,
    MethodsStrGet,
    MethodsStrSingleGet,
    MethodsStrSabitGet,
    MethodsStrFilterGet,
    MethodsStrFileGet,
    MethodsStrPost,
    MethodsStrPut,
    MethodsStrDelete, 
    MethodsStrAllPut,
    MethodsReport,
    GenericComputed 
    } from "@/state/helpers";

    import moment from "moment"; 

const Sabit = {
    data() {
      return { 

      }
    },
    methods: {
    ...MethodsFastReport,
    ...MethodsStrGet,
    ...MethodsStrSingleGet,
    ...MethodsStrSabitGet,
    ...MethodsStrFilterGet,
    ...MethodsStrFileGet,
    ...MethodsStrPost,
    ...MethodsStrPut,
    ...MethodsStrAllPut, ...MethodsReport,
    ...MethodsStrDelete, 
                ChangePage(DefaultPage) {
                    if(DefaultPage){ 
                        this.Page.PageNumber = DefaultPage

                          this.$nextTick(() => {
                            if (typeof this.Get === "function") {
                              this.Get();
                            }
                          });
                    }
                },
                ExcelExport(table, name) {
                  const uri = "data:application/vnd.ms-excel;base64,";
                  const template =
                    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta http-equiv="content-type" content="text/plain; charset=utf-8"></head><body><table>{table}</table></body></html>';
                
                  const base64 = (s) => window.btoa(unescape(encodeURIComponent(s)));
                
                  const format = (s, c) => s.replace(/{(\w+)}/g, (m, p) => c[p]);
                
                  if (!table.nodeType) table = this.$refs.ExcelExportTable;
                
                  let tableHtml = table.innerHTML
                    .replace(/<ul>\s*<\/ul>/g, '') // boş ul'leri kaldır
                    .replace(/<li>\s*<\/li>/g, '') // boş li'leri kaldır
                    .replace(/<li>/g, '<li>• ') // liste maddesi başına nokta koy
                    .replace(/<ul>|<\/ul>/g, '') // ul etiketlerini tamamen kaldır (isteğe bağlı)
                    .replace(/\n/g, ''); // satır sonlarını kaldır
                
                  const ctx = { worksheet: name || "Worksheet", table: tableHtml };
                  const a = document.createElement('a');
                  a.href = uri + base64(format(template, ctx));
                  a.download = name + '.xls';
                  a.click();
                }
,                
                Export2Word(element, filename) {
                  var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
                  var postHtml = "</body></html>";
                  var content = document.getElementById(element).innerHTML;
                  console.log(content)

                  content = content.replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' '); 
                  
                  var html = preHtml + content + postHtml;
                  var blob = new Blob(['\ufeff', html], {
                      type: 'application/msword'
                  });
                  var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
                  filename = filename ? filename + '.doc' : 'document.doc';
                  var downloadLink = document.createElement("a");
                  document.body.appendChild(downloadLink);
                  
                  if (navigator.msSaveOrOpenBlob) {
                      navigator.msSaveOrOpenBlob(blob, filename);
                  } else {
                      downloadLink.href = url;
                      downloadLink.download = filename;
                      downloadLink.click();
                  }
                  
                  document.body.removeChild(downloadLink);
              },              
                RolesControl(KullaniciRolleri,Rol){ 
                  let YetkiSorgu = KullaniciRolleri.filter((item) =>
                  item.includes(Rol)
                  );
                  if (YetkiSorgu.length != 0) return true; 
                  else  return false;  
                },
              
               
    },
    computed: {
      ...GenericComputed 
    }, 
    created(){   
        this.$nextTick(() => {
          if (typeof this.Get === "function") {
            this.Get();
          }
        });
    }, 
    mounted() {
      setTimeout(() => {
        this.showModal = true;
      }, 1500);
    }, 
    filters: {
      formatNoktaToVirgul(value) {
        if (value) { 
          return  value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 3 });
        }
        else{
          return value;
        }
      },
      formatNoktaToVirgulMax3(value) {
        if (value) { 
          return  value.toLocaleString('tr-TR', { maximumFractionDigits: 3 });
        }
        else{
          return value;
        }
      },
      formatDate(value) {
        if (value) {
          return moment(String(value)).format("YYYY-MM-DD");
        }
      },
      formatDateOnlyYear(value) {
        if (value) {
          return moment(String(value)).format("YYYY");
        }
      },
      formatDateTable(value) {
        if (value) {
          return moment(String(value)).format("DD.MM.YYYY");
        }
      },
      TrParaFormat(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") 
      },
    },
     
  }

 
 
  export default Sabit
